// Money formatting shared by the public registration pages (registration,
// registrations, account). 1.0's public form rules (built-in fields, the
// quote, submit blockers) lived here too; they went with the public form
// page when Forms were retired at registration step R (decision 25).

import { fmtMoney } from '@/i18n'

export function usd(cents: number): string {
  return fmtMoney(cents, 'USD')
}
